import { IncidentsWebComponent } from '../component/IncidentsWebComponent';
import { IncidentsView } from '../view/IncidentsView';
import { templateIncidents } from '../view/template';
import { BaseWidgetController } from '../../widget/BaseWidgetController';
import { GetIncidentsStatusResponse } from '@nirvana/shared/dtos/types/widgets/common';

export class IncidentsController extends BaseWidgetController<GetIncidentsStatusResponse> {
  public component: IncidentsWebComponent;
  public view: IncidentsView;
  public viewConstructor: typeof IncidentsView;

  constructor(component: IncidentsWebComponent) {
    super(component);
    this.initialWidgetSetup({
      viewConstructor: IncidentsView,
      viewTemplate: templateIncidents,
      dataFetchMethod: this.component.dependencies.api.clients.Widgets.getIncidentsStatus,
    });
  }
}
